const React = require('react');

const AdminTitle = require('../AdminTitle');
const HeaderStatistics = require('./components/HeaderStatistics');
const {BtnAddNew, BtnBack} = require('../../../Buttons');

module.exports = ({title, statistic, backLink, backAction, newUserData, additionalData}) => {
  return (
    <div className="h45 layoutRow fxwWrap jcSB aiC hAuto@m2">
      <div className="layoutRow jcFS aiC">
        {(backLink || backAction) && (
          <div className="mr20">
            <BtnBack
              link={backLink}
              onClick={backAction}
            />
          </div>
        )}
        <div className="layoutRow jcFS aiFE dB@m4">
          <div className="mr24">
            <AdminTitle text={title} />
          </div>
          <div>
            <HeaderStatistics {...statistic} />
          </div>
        </div>
      </div>
      <div className="mv10@m2">
        {newUserData && <BtnAddNew {...newUserData} />}
        {additionalData}
      </div>
    </div>
  )
}
